import Parse from 'html-react-parser';

function BMP20213(props) {
    let svgCode =
    `<svg width="36" height="72" viewBox="0 0 36 72" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="34" height="34" rx="3" fill="${props.darkFill}" fill-opacity="0.5"/>
        <path d="M7.93786 28.4338L8.45071 22.8111L13.5392 27.725L7.93786 28.4338Z" fill="black" fill-opacity="0.5"/>
        <path d="M14.969 26.4565L9.93362 21.5939L18.837 12.3742L23.8724 17.2368L14.969 26.4565Z" fill="black" fill-opacity="0.5"/>
        <path d="M25.258 15.8019L20.2227 10.9393L23.1838 7.87296L28.2192 12.7356L25.258 15.8019Z" fill="black" fill-opacity="0.5"/>
        <rect x="1" y="37" width="34" height="34" rx="3" fill="${props.highlightColour}"/>
        <path d="M7.93786 64.4338L8.45071 58.8111L13.5392 63.725L7.93786 64.4338Z" fill="white"/>
        <path d="M14.969 62.4565L9.93362 57.5939L18.837 48.3742L23.8724 53.2368L14.969 62.4565Z" fill="white"/>
        <path d="M25.258 51.8019L20.2227 46.9393L23.1838 43.873L28.2192 48.7356L25.258 51.8019Z" fill="white"/>
    </svg>`

    props.svgReturn(62, svgCode, "bmp00213", 36, 72);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20213;